// extracted by css-extract-rspack-plugin
export default {"LegendItem":"aMeNc","LegendHeader":"omIAu","LegendItemMuted":"aN3hv","Legend":"ZVH09","none":"q9L2x","vertical":"r0JPc","horizontal":"gTNVY","DashCard":"KY_Tw"};